import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=8deca20e&scoped=true&"
import script from "./VideoComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=8deca20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deca20e",
  null
  
)

export default component.exports